import { createAction, createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';
import { type SagaConfig } from '@sagas/request/types';

import { type CredentialsState } from './types';

export const initialState: CredentialsState = {
  meta: {
    errorMessage: '',
    status: STATUS.LOADING,
    isAllValid: false,
    isEcommerce: false,
  },
  model: [],
};

export const credentialsRequest = createAction<{ entityId: string; sagaConfig?: SagaConfig }>(
  'credentials/request'
);
export const credentialsUpdateRequest = createAction<{
  region: string;
  entityId: string;
  sagaConfig?: SagaConfig;
}>('credentialsUpdate/request');

export const checkValidCredentialsRequest = createAction<{
  entityId: string;
  sagaConfig?: SagaConfig;
}>('credentials-valid/request');

export const credentialsDeleteRequest = createAction<{
  credentialsId: string;
  entityId: string;
  sagaConfig?: SagaConfig;
}>('credentials-valid/deleteRequest');

export const credentialsDeleteFailure = createAction('credentials-valid/deleteFailure');

const credentials = createSlice({
  name: 'credentials',
  initialState,
  reducers: {
    reset: () => initialState,
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.meta.isEcommerce = action.payload.result.isEcommerce;
      state.model = action.payload.result.data;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
    setValid: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.meta.isAllValid = action.payload.result || false;
    },
    deleteSuccess: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.meta.isEcommerce = action.payload.result.isEcommerce;
      state.model = action.payload.result.data;
    },
  },
  extraReducers: builder => {
    builder.addCase(credentialsRequest.type, state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    });
    builder.addCase(credentialsDeleteRequest.type, state => {
      state.meta.status = STATUS.LOADING;
    });
    builder.addCase(credentialsDeleteFailure.type, state => {
      state.meta.status = STATUS.SUCCESS;
    });
    builder.addCase(checkValidCredentialsRequest.type, state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    });
  },
});

export const {
  reset: credentialsReset,
  success: credentialsSuccess,
  failure: credentialsFailure,
  setValid: credentialsSetValid,
  deleteSuccess: credentialsDeleteSuccess,
} = credentials.actions;

export default credentials.reducer;
